var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3154(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_130",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3377",
    "data-name": "Rectangle 3377",
    width: 14,
    height: 14,
    fill: "#1B453E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3154",
    "data-name": "Group 3154",
    transform: "translate(-312 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 312, 158)",
    filter: "url(#Ellipse_130)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130-2",
    "data-name": "Ellipse 130",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(15 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Switch",
    transform: "translate(335 181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M13.937,4.229a2.8,2.8,0,0,0-2.773-2.214H1.533l.885-.878.2-.195C2.748.811,2.874.686,3,.563L3,.555,2.992.543C2.8.349,2.624.173,2.454.005L2.448,0l0,0C1.734.712.975,1.472,0,2.447c.827.828,1.637,1.64,2.448,2.447.2-.19.394-.39.558-.559-.007-.008-.014-.018-.024-.028l-.321-.322c-.051-.051-.149-.151-.2-.2l-.9-.9h9.557a1.928,1.928,0,0,1,2.019,1.928c0,.062.032.169.122.182a2.192,2.192,0,0,0,.305.021,2.668,2.668,0,0,0,.325-.02c.017,0,.057-.007.116-.132V4.565l-.015-.086c-.016-.088-.03-.171-.048-.25",
    fill: "#1B453E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M.063,193.4a2.8,2.8,0,0,0,2.773,2.214h9.631l-.885.878-.2.194c-.133.132-.259.256-.381.379l-.007.008.011.011c.192.195.368.371.538.538l.006.005,0,0c.711-.709,1.471-1.469,2.445-2.445-.827-.828-1.637-1.64-2.448-2.447-.2.19-.394.39-.558.559.007.008.014.018.024.028l.321.322c.051.051.149.151.2.2l.9.9H2.886a1.928,1.928,0,0,1-2.019-1.928c0-.062-.032-.169-.122-.182a2.192,2.192,0,0,0-.305-.021,2.665,2.665,0,0,0-.325.02c-.017,0-.057.007-.116.132v.294l.015.086c.016.088.03.171.048.25",
    transform: "translate(0 -183.631)",
    fill: "#1B453E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3154);
export default __webpack_public_path__ + "static/media/Group 3154.d83412f5e0da2fadc2930402a102dada.svg";
export { ForwardRef as ReactComponent };